<template>
  <v-app id="vapp" class="darkcmpbk">
    <!-- *RPD Forms  Appv 0.91
* Copyright (c) 2025, Blue Cover Six LLC . All rights reserved.
Code licensed under contract To Reno Police Department / City of Reno, in perpetuity -->

    <v-overlay opacity="0.97" :z-index="zIndex" :value="overlay">
      <v-progress-circular
        :size="50"
        style="z-index: 5200"
        color="deep-orange accent-2"
        indeterminate
      >
      </v-progress-circular>
    </v-overlay>

    <!-- mobile menu bar  hidden-sm-and-up -->
    <v-row class="menu-bar-row">
      <v-col cols="12">
        <v-app-bar
          id="menu-bar-mobile"
          fixed
          app
          class="d-flex d-sm-none secondary"
          absolute
          dense
          white--text
        >
          <!-- <v-app-bar-nav-icon
            v-show="true"
            @click="drawer = false"
            style="color: aliceblue"
          ></v-app-bar-nav-icon> -->
          <!-- <v-spacer></v-spacer> -->
          <div class="d-flex align-center">
            <img
              style="cursor: pointer"
              @click="gohome"
              height="40"
              class="img1 mr-4"
              src="../images/gold-badge-320.png"
            />
            <!-- <router-link class="mr-4" to="/">Home</router-link> -->
            <!-- <router-link class="green--text to-do" to="/ToDo"
              >ToDo.vue</router-link
            > -->
          </div>

          <h4>RPD MHOR</h4>

          <!-- <v-img
            max-width="48px"
            height="48px"
            width="auto"
            src="../images/gold-badge-48px.png"
          ></v-img> -->
          <!-- <v-spacer></v-spacer> -->

          <div id="div_logoff">
            <v-btn icon text v-show="true" @click="toggle_logoff">
              <v-icon x-large style="color: lightslategrey">$person</v-icon>
            </v-btn>
          </div>
        </v-app-bar>
      </v-col>
    </v-row>
    <div
      class="text-white"
      @click="logoff"
      style="
        z-index: 500;
        background-color: darkslategrey;
        text-decoration: underline;
        cursor: pointer;
        position: absolute;
        top: 40px;
        right: 50px;
        padding: 10px;
        border-radius: 4px;
        border: 1px solid white;
      "
      v-if="showLogoff"
    >
      Logoff: {{ user_email }}
    </div>
    <v-navigation-drawer
      id="v-navigation-drawer"
      class="white--text mt-11"
      style=""
      v-model="drawer"
      height="215"
      width="175"
      accent
      absolute
      temporary
    >
      <v-list nav dense close-on-click close-on-content-click>
        <v-list-item-group v-model="group" class="white--text">
          <v-list-item>
            <router-link class="white--text" to="/">Home</router-link>
          </v-list-item>

          <v-list-item>
            <router-link class="white--text" to="/ToDo">ToDo.vue</router-link>
          </v-list-item>
          <!-- <v-list-item>
            <router-link class="white--text" to="/data_table"
              >List - data_table.vue</router-link
            >
          </v-list-item> -->
          <v-list-item>
            <a
              class="white--text"
              href="https://rpdportal.org/?returnURL=https://mhor.renopdportal.org"
              target="_blank"
              >Apps Home - back to portal</a
            >
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <!-- Large Menu Bar -->
    <v-row class="menu-bar-row">
      <v-col cols="12">
        <v-app-bar
          id="menu-bar-large"
          app
          class="app_vue_comp flex-row align-center justify-space-between white--text hidden-xs-only secondary"
          elevation="4"
          style="height: 50px"
        >
          <div class="d-flex align-center home-todo">
            <img
              style="cursor: pointer"
              @click="gohome"
              class="img1 mr-4"
              src="../images/gold-badge-320.png"
            />
            <!-- <router-link class="mr-4" to="/">Home</router-link> -->
            <!-- <router-link class="green--text to-do" to="/ToDo"
              >ToDo.vue</router-link
            > -->
          </div>

          <h4 class="title text-center">RPD MHOR</h4>
          <div id="div_logoff" class="logoff text-right">
            <v-btn icon text v-show="true" @click="toggle_logoff">
              <v-icon x-large style="color: lightslategrey">$person</v-icon>
            </v-btn>
          </div>
        </v-app-bar>
      </v-col>
    </v-row>

    <v-main id="main">
      <Transition name="fade-transition" mode="out-in">
        <router-view />
      </Transition>
    </v-main>
  </v-app>
</template>

<style>
/* 0 media q */
@media (min-width: 0px) {
  .v-main {
    padding: 5px 0 0 0 !important;
    height: 100dvh;
  }
  .menu-bar-row {
    height: 50px;
    flex-grow: 0 !important;
  }

  #vapp {
    /* background-color: var(--v-background-base); */
    overflow-x: hidden;
    overflow-y: auto;
    max-height: 100vh;
    height: 100vh;
    /* background-color: orange; */
    min-height: 100%;
    max-width: 768px;
    margin: 0 auto;
    /* background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center;
    background-size: cover; */
  }

  .v-toolbar {
    max-width: 768px;
    margin: 0 auto;
  }

  #menu-bar-large .v-toolbar__content,
  #menu-bar-mobile .v-toolbar__content {
    width: 100%;
    max-width: 1024px;
    height: 50px !important;
    margin: 0 auto;
    align-items: center;
    justify-content: space-between;
  }

  #menu-bar-large img.img1 {
    width: 48px;
  }

  #menu-bar-mobile .v-application:deep .primary {
    background-color: aliceblue !important;
    border-color: aliceblue !important;
  }

  .my-active-class {
    color: orange;
  }

  #v-navigation-bar {
    background-color: #2c3e50;
  }
  .bk-color {
    margin: 5px;
    border-radius: 4px;
  }
  .bk-color:hover {
    background: #bbdefb;
  }
  .bk-color:active {
    background: #e3f2fd;
  }

  /* .img2 img {
    width: 400px;
  }

  .img3 img {
    width: 400px;
  } */

  #menu-bar-large a {
    color: white;
    text-decoration: none;
    font-size: 1.2rem;
  }

  #menu-bar-large a:hover {
    color: #e3cc67;
  }

  #menu-bar-large a:active {
    color: #b08533;
  }

  .swal2-popup {
    /* font-size: 1.15rem !important;*/
    font-family: "Roboto", sans-serif !important;
  }
  .v-btn--active.no-active::before {
    opacity: 0 !important;
  }

  .v-btn--active.no-active:not(:hover)::before {
    opacity: 0 !important;
  }
}

@media only screen and (max-width: 600px) {
  #vapp {
    max-height: 93vh;
  }
}

@media (min-width: 768px) {
  #vapp {
    max-width: 1024px;
  }

  .v-toolbar {
    max-width: 1024px;
  }

  .home-todo,
  .title,
  .logoff {
    width: 33.3%;
  }
}

@media (min-width: 1025px) {
  /* #vapp {
    background-image: url("../images/reno-hero_1920.png");
    background-image: url("../images/hero_placeholder.jpg");
    background-position: 0 100px;
    max-width: 768px;
  } */
}

@media (min-width: 2048px) {
}
</style>

<script>
// import brandbar from "./brandbar";
import { bus_common } from "../mixins/bus_common";
export default {
  name: "App",
  mixins: [bus_common],
  // components: { deployment_logs },

  data() {
    return {
      user_email: "",
      showLogoff: false,
      zIndex: 4000,
      drawer: false,
      group: null,
    };
  },
  watch: {
    "$store.state.loader_visible": function () {
      //console.log("app loader_visible " + this.$store.state.loader_visible );
    },
    "$store.state.user": function () {
      //keep this
      if (this.$store.state.user != "") {
        this.user_email = this.$store.state.user.email;
      }
    },
  },
  computed: {
    overlay: function () {
      return this.$store.state.loader_visible;
    },
  },
  methods: {
    gohome() {
      window.location.reload();
    },
    toggle_logoff() {
      this.showLogoff = !this.showLogoff;
    },
    logoff() {
      window.location.replace(
        "https://rpdportal.org/?returnURL=https://mhor.renopdportal.org/"
      );
    },

    logout() {
      this.swall_diag(
        "Log Out?",
        "Are you sure you would like to log out?",
        "question",
        null,
        "Yes",
        "No",
        null
      );
    },
  },
  created() {
    this.show_loader(true);
  },
};
</script>
